// GENERATED FILE - DO NOT MODIFY

export enum GroupingTypeDto {
    TimeUnit = "TimeUnit",
    Office = "Office",
    OfficeSpace = "OfficeSpace",
    WorkType = "WorkType",
    WeekDay = "WeekDay",
    DayFourHoursPeriod = "DayFourHoursPeriod",
}